import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3254d708")

_pushScopeId("data-v-3254d708")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Profilo")
const _hoisted_2 = { class: "page_content" }
const _hoisted_3 = { class: "attachment_modal" }
const _hoisted_4 = { class: "profile_image_container" }
const _hoisted_5 = { class: "action_container" }
const _hoisted_6 = { class: "main_info" }
const _hoisted_7 = { class: "main_info_text" }
const _hoisted_8 = { class: "user_type" }
const _hoisted_9 = { class: "user_name" }
const _hoisted_10 = { class: "user_email" }
const _hoisted_11 = { class: "user_info" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "section_title" }, "Le tue informazioni", -1)
const _hoisted_13 = { class: "container_user_info" }
const _hoisted_14 = { class: "user_avatar_container ion-hide" }
const _hoisted_15 = { class: "username" }
const _hoisted_16 = { class: "single_user_info" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Codice fiscale", -1)
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "single_user_info" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Cellulare", -1)
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "single_user_info" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Data nascita", -1)
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "single_user_info" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Luogo nascita", -1)
const _hoisted_27 = { class: "value" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "single_user_info" }, [
  /*#__PURE__*/_createVNode("div", { class: "title" }, "Versione applicazione"),
  /*#__PURE__*/_createVNode("div", { class: "value" }, "3.4")
], -1)
const _hoisted_29 = { class: "badge_container" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "title" }, "Badge Virtuale", -1)
const _hoisted_31 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_32 = {
  key: 0,
  style: {"width":"150px","height":"150px","display":"flex","justify-content":"center","align-items":"center"}
}
const _hoisted_33 = {
  key: 1,
  style: {"width":"150px","height":"150px"}
}
const _hoisted_34 = { class: "actions_container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_title = _resolveComponent("ion-title")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_buttons = _resolveComponent("ion-buttons")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_header = _resolveComponent("ion-header")
  const _component_ion_avatar = _resolveComponent("ion-avatar")
  const _component_ion_spinner = _resolveComponent("ion-spinner")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_title, { color: "white" }, {
                default: _withId(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openMenu())),
                slot: "start"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        icon: $setup.menu,
                        slot: "start",
                        color: "white"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_Transition, { name: "fade-transition" }, {
              default: _withId(() => [
                _withDirectives(_createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("img", {
                      src: $setup.newProfileImage,
                      alt: "Foto rapportino"
                    }, null, 8, ["src"]),
                    _createVNode("div", _hoisted_5, [
                      _createVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.savePhoto())),
                        disabled: $setup.savingPhoto,
                        class: "btn_upload_photo"
                      }, "Salva foto", 8, ["disabled"]),
                      _createVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.closeModal())),
                        disabled: $setup.savingPhoto,
                        class: "btn_close_modal"
                      }, "Annulla", 8, ["disabled"])
                    ])
                  ])
                ], 512), [
                  [_vShow, $setup.showThumb]
                ])
              ]),
              _: 1
            }),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, _toDisplayString($setup.user.users_type_value), 1),
                _createVNode("div", _hoisted_9, _toDisplayString($setup.user.dipendenti_nome) + " " + _toDisplayString($setup.user.dipendenti_cognome), 1),
                _createVNode("div", _hoisted_10, _toDisplayString($setup.user.dipendenti_email), 1)
              ]),
              _createVNode("div", {
                class: "user_image",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.loadNewImage()))
              }, [
                _createVNode(_component_ion_avatar, { style: {"width":"100px","height":"100px","border":"4px solid #ffffff"} }, {
                  default: _withId(() => [
                    _createVNode("img", { src: $setup.profileImagePath }, null, 8, ["src"])
                  ]),
                  _: 1
                }),
                _createVNode("input", {
                  type: "file",
                  ref: "fileInput",
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleImageUpload && $setup.handleImageUpload(...args))),
                  accept: "image/*",
                  style: {"display":"none"}
                }, null, 544)
              ])
            ]),
            _createVNode("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode(_component_ion_avatar, null, {
                    default: _withId(() => [
                      _createVNode("img", {
                        src: $setup.setImage($setup.user)
                      }, null, 8, ["src"])
                    ]),
                    _: 1
                  }),
                  _createVNode("div", _hoisted_15, _toDisplayString($setup.user.dipendenti_nome) + " " + _toDisplayString($setup.user.dipendenti_cognome), 1)
                ]),
                _createVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, _toDisplayString($setup.user.dipendenti_codice_fiscale || "-"), 1)
                ]),
                _createVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, _toDisplayString($setup.user.dipendenti_cellulare || "-"), 1)
                ]),
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode("div", _hoisted_24, _toDisplayString($setup.dateFormat($setup.user.dipendenti_data_nascita) || "-"), 1)
                ]),
                _createVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, _toDisplayString($setup.user.dipendenti_luogo_nascita || "-"), 1)
                ]),
                _hoisted_28
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode("div", _hoisted_31, [
                ($setup.loadingQR)
                  ? (_openBlock(), _createBlock("span", _hoisted_32, [
                      _createVNode(_component_ion_spinner, {
                        name: "crescent",
                        color: "secondary",
                        style: {"width":"32px","height":"32px"}
                      })
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_33, [
                      _createVNode("img", { src: $setup.b64Image }, null, 8, ["src"])
                    ]))
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("div", {
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.updateApp && $setup.updateApp(...args))),
                class: "btn_force_update"
              }, " Forza aggiornamento "),
              _createVNode("div", {
                class: "btn_change_password",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.openAutorizzazioni && $setup.openAutorizzazioni(...args)))
              }, " Autorizzazioni "),
              _createVNode("div", {
                class: "btn_change_password",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.changePassword && $setup.changePassword(...args)))
              }, " Modifica password "),
              _createVNode("div", {
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.logOut && $setup.logOut(...args))),
                class: "btn_logout"
              }, "Logout")
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})